import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";
import Quote from "@/pages/Quote";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingCancel from "@/pages/BookingCancel";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import JobSheet from "@/pages/JobSheet";
import Track from "@/pages/Track";
import QuoteView from "@/pages/QuoteView";
import CarTransport from "@/pages/services/CarTransport";
import VehicleRecovery from "@/pages/services/VehicleRecovery";
import NonRunnerTransport from "@/pages/services/NonRunnerTransport";
import NationwideVehicleTransport from "@/pages/services/NationwideVehicleTransport";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/quote/:ref" element={<QuoteView />} />
          <Route path="/track" element={<Track />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/booking/cancel" element={<BookingCancel />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/bookings/:ref/sheet" element={<JobSheet />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/car-transport" element={<CarTransport />} />
          <Route path="/vehicle-recovery" element={<VehicleRecovery />} />
          <Route path="/non-runner-transport" element={<NonRunnerTransport />} />
          <Route path="/nationwide-vehicle-transport" element={<NationwideVehicleTransport />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid #2A2A2A",
            color: "#fff",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
